module.exports = __webpack_public_path__ + "static/media/icon-copy.946b4e71.svg";